"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountApiV1 = exports.accountApi = void 0;
const createApi_1 = require("../../helpers/createApi");
const list = (caller) => ({ accountName, page, maxPerPage, testId, flagshipAccountId }) => {
    const query = {
        _page: page,
        _max_per_page: maxPerPage,
        pattern: accountName,
        test_id: testId,
        flagship_account_id: flagshipAccountId,
        '_order[name]': 'ASC',
    };
    return caller(`/accounts`).get(query);
};
const get = (caller) => ({ accountId, extended, pattern, ...otherParams }) => {
    return caller(`/accounts/${accountId}`).get({ extended, pattern, ...otherParams });
};
const patch = (caller) => ({ accountId, payload }) => {
    return caller(`/accounts/${accountId}`).patch(payload);
};
const postNotification = (caller) => ({ accountId, type, context }) => {
    const url = `backend/accounts/${accountId}/notify?type=${type}&context=${context}`;
    return caller(url).post({});
};
const createTagDelegatedDomain = (caller) => ({ accountId, hostname }) => caller(`backend/accounts/${accountId}/tag-delegated-domain?host_name=${encodeURIComponent(hostname)}`).post();
const getTagDelegatedDomain = (caller) => ({ accountId }) => caller(`backend/accounts/${accountId}/tag-delegated-domain`).get();
exports.accountApi = (0, createApi_1.createAPIFactory)({
    postUpgradeRequestSlack: postNotification,
    createTagDelegatedDomain,
    getTagDelegatedDomain,
});
exports.accountApiV1 = (0, createApi_1.createAPIFactory)({
    get,
    list,
    patch,
});
//# sourceMappingURL=api.js.map